export const API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:4000/api/v1"
    : "https://guaranteexbe-production.up.railway.app/api/v1";
